<script lang="ts">
    import { useNavigate } from "svelte-navigator";
    import { beforeUpdate, onDestroy, onMount } from "svelte";
    import { roundNumber } from "../../../../../GlobalHelper/Util";

    export let title: String;
    export let decimals: number = 2;
    export let amount: number = 0;
    export let unit: string = "";

    let lastAmount = 0;
    let counterElement;

    function animateValue(obj, start, end, duration) {
        lastAmount = end;
        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min(
                (timestamp - startTimestamp) / duration,
                1
            );
            if (obj) {
                obj.innerHTML =
                    roundNumber(progress * (end - start) + start, decimals) +
                    " " +
                    unit;
            }
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }

    const interval = setInterval(() => {
        animateValue(counterElement, lastAmount, amount, 990);
    }, 1000);

    // $: animateValue(counterElement, lastAmount, amount, 300);

    onMount(() => {
        // animateValue(counterElement, lastAmount, amount, 300);
    });

    onDestroy(() => {
        clearInterval(interval);
    });
</script>

<div class="column is-4">
    <div class="height-hundred" />
    <div class="rounded-box-outer">
        <div class="rounded-box-inner">
            <div class="rounded-box">
                <div class="key-performance-indicator">
                    <p class="title is-4" id="value">
                        {roundNumber(amount, 0)}
                        {unit}
                    </p>
                </div>
                <p class="is-5">{title}</p>
            </div>
        </div>
    </div>
</div>

<style>
    .key-performance-indicator {
        width: 100%;
        align-items: center;
        display: inline-flex;
        font-size: 1.25rem;
        justify-content: center;
        padding: 0.25rem 0.5rem;
        text-align: center;
        vertical-align: top;
    }

    p {
        text-align: center;
    }

    .height-hundred {
        margin-top: 69%;
    }

    .rounded-box-outer {
        position: absolute;
        top: 0.75rem;
        bottom: 0.75rem;
        left: 0.75rem;
        right: 0.75rem;
    }

    .rounded-box-inner {
        margin: auto;
        background-image: linear-gradient(
            to bottom,
            #14acab 0%,
            #238aae 51%,
            #2765af 100%
        );
        max-height: 15rem;
        max-width: 15rem;
        height: 100%;
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 20rem;
    }

    .rounded-box {
        background: white;
        max-height: 11rem;
        max-width: 11rem;
        height: 100%;
        width: 100%;
        padding: 3rem 1rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 20rem;
    }

    .column {
        position: relative;
    }
</style>
